import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

/**
 * Read-only Markdown renderer for comments.
 * Styled to be compact and respect Sprintroll's light/dark theme.
 */
export default function Markdown({ children }) {
  return (
    <div className="prose-sm max-w-none text-sm leading-relaxed [&_p]:my-1 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_li]:my-0.5 [&_blockquote]:border-l-2 [&_blockquote]:border-blue-500/60 [&_blockquote]:pl-3 [&_blockquote]:text-muted-foreground [&_code]:px-1 [&_code]:py-0.5 [&_code]:rounded [&_code]:bg-white/60 dark:[&_code]:bg-white/10 [&_code]:text-[0.85em] [&_a]:text-blue-600 dark:[&_a]:text-blue-400 [&_a]:underline [&_a]:underline-offset-2 [&_strong]:font-semibold">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: (props) => <a {...props} target="_blank" rel="noreferrer noopener" />,
        }}
      >
        {children || ""}
      </ReactMarkdown>
    </div>
  );
}
